import AgentCommissionProvider from "../resource/agentCommission";

const AgentCommissionService = new AgentCommissionProvider();

const state = {
    tiers: [],
    profiles: [],
    agents: [],
    rounds: [],
    currentRound: null,
    previewResult: null,
    remittanceBatches: [],
    remittanceUnmatched: [],
};

const getters = {
    getTiers: state => state.tiers,
    getProfiles: state => state.profiles,
    getAgents: state => state.agents,
    getRounds: state => state.rounds,
    getCurrentRound: state => state.currentRound,
    getPreviewResult: state => state.previewResult,
    getRemittanceBatches: state => state.remittanceBatches,
    getRemittanceUnmatched: state => state.remittanceUnmatched,
};

const mutations = {
    SET_TIERS(state, data) {
        state.tiers = data;
    },
    SET_PROFILES(state, data) {
        state.profiles = data;
    },
    SET_AGENTS(state, data) {
        state.agents = data;
    },
    SET_ROUNDS(state, data) {
        state.rounds = data;
    },
    SET_CURRENT_ROUND(state, data) {
        state.currentRound = data;
    },
    SET_PREVIEW_RESULT(state, data) {
        state.previewResult = data;
    },
    CLEAR_PREVIEW(state) {
        state.previewResult = null;
    },
    SET_REMITTANCE_BATCHES(state, data) {
        state.remittanceBatches = data;
    },
    SET_REMITTANCE_UNMATCHED(state, data) {
        state.remittanceUnmatched = data;
    },
};

const actions = {
    async fetchTiers({ commit }) {
        try {
            const resp = await AgentCommissionService.TierList();
            commit("SET_TIERS", resp.data.Data || []);
            return resp;
        } catch (error) {
            commit("SET_TIERS", []);
            throw error;
        }
    },
    replaceTiers({ commit }, tiers) {
        return AgentCommissionService.TierReplace(tiers);
    },

    // ---- Profiles ----
    async fetchProfiles({ commit }) {
        try {
            const resp = await AgentCommissionService.ProfileList();
            commit("SET_PROFILES", resp.data.Data || []);
            return resp;
        } catch (error) {
            commit("SET_PROFILES", []);
            throw error;
        }
    },
    fetchProfile({ commit }, id) {
        return AgentCommissionService.ProfileGet(id);
    },
    createProfile({ commit }, payload) {
        return AgentCommissionService.ProfileCreate(payload);
    },
    updateProfile({ commit }, { id, payload }) {
        return AgentCommissionService.ProfileUpdate(id, payload);
    },
    deleteProfile({ commit }, id) {
        return AgentCommissionService.ProfileDelete(id);
    },

    // ---- Agents ----
    async fetchAgents({ commit }) {
        try {
            const resp = await AgentCommissionService.AgentList();
            commit("SET_AGENTS", resp.data.Data || []);
            return resp;
        } catch (error) {
            commit("SET_AGENTS", []);
            throw error;
        }
    },
    setAgentProfile({ commit }, { userId, profileId }) {
        return AgentCommissionService.AgentSetProfile(userId, profileId);
    },

    // ---- Remittance ----
    importRemittance({ commit }, { file, carrier }) {
        return AgentCommissionService.RemittanceImport(file, carrier);
    },
    remittanceImportStatus({ commit }) {
        return AgentCommissionService.RemittanceImportStatus();
    },
    async fetchRemittanceBatches({ commit }) {
        try {
            const resp = await AgentCommissionService.RemittanceBatchList();
            commit("SET_REMITTANCE_BATCHES", resp.data.Data || []);
            return resp;
        } catch (error) {
            commit("SET_REMITTANCE_BATCHES", []);
            throw error;
        }
    },
    async fetchRemittanceUnmatched({ commit }) {
        try {
            const resp = await AgentCommissionService.RemittanceUnmatched();
            commit("SET_REMITTANCE_UNMATCHED", resp.data.Data || []);
            return resp;
        } catch (error) {
            commit("SET_REMITTANCE_UNMATCHED", []);
            throw error;
        }
    },
    matchRemittanceRow({ commit }, { rowId, boOrderId }) {
        return AgentCommissionService.RemittanceRowMatch(rowId, boOrderId);
    },
    unmatchRemittanceRow({ commit }, rowId) {
        return AgentCommissionService.RemittanceRowUnmatch(rowId);
    },

    // ---- Rounds ----
    async fetchRounds({ commit }) {
        try {
            const resp = await AgentCommissionService.RoundList();
            commit("SET_ROUNDS", resp.data.Data || []);
            return resp;
        } catch (error) {
            commit("SET_ROUNDS", []);
            throw error;
        }
    },
    async previewRound({ commit }, code) {
        try {
            const resp = await AgentCommissionService.RoundPreview(code);
            commit("SET_PREVIEW_RESULT", (resp.data.Data && resp.data.Data[0]) || null);
            return resp;
        } catch (error) {
            commit("CLEAR_PREVIEW");
            throw error;
        }
    },
    createRound({ commit }, payload) {
        return AgentCommissionService.RoundCreate(payload);
    },
    async fetchRound({ commit }, id) {
        try {
            const resp = await AgentCommissionService.RoundGet(id);
            const item = resp.data.Data && resp.data.Data[0];
            // BE returns { round: {...}, agents: [...] }; flatten into a single object for the view.
            const merged = item ? Object.assign({}, item.round, { agents: item.agents || [] }) : null;
            commit("SET_CURRENT_ROUND", merged);
            return resp;
        } catch (error) {
            commit("SET_CURRENT_ROUND", null);
            throw error;
        }
    },
    fetchAgentOrders({ commit }, { id, userId }) {
        return AgentCommissionService.RoundAgentOrders(id, userId);
    },
    deleteRound({ commit }, id) {
        return AgentCommissionService.RoundDelete(id);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
